<template>
  <div class="card border-start border-start-width-3 border-start-teal">
    <div class="card-header">
      <h6 class="mb-0">
        Associar Natureza Orçamentário ao Centro de Custo
        {{ filters.codCCustoFilho }}
      </h6>
    </div>
    <div class="card-body">
      <form @submit.prevent="createAssociacaoNaturezaOrcamentaria">
        <div class="row g-3">
          <div class="col-md-9">
            <select
              class="form-select select2"
              v-model="v$.codTBOrcamento.$model"
              v-select2
            >
              <option value="" disabled>
                Selecione uma natureza orçamentária
              </option>
              <option
                v-for="naturezaOrcamentaria in naturezasOrcamentarias"
                :key="naturezaOrcamentaria.codTBOrcamento"
                :value="naturezaOrcamentaria.codTBOrcamento"
                :title="`${naturezaOrcamentaria.codTBOrcamento} - ${naturezaOrcamentaria.descricao}`"
              >
                {{ naturezaOrcamentaria.codTBOrcamento }} -
                {{ naturezaOrcamentaria.descricao }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <button
              type="submit"
              class="btn btn-success w-100"
              title="Associar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Associar</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import select2 from 'select2'

export default {
  name: 'AssociarNaturezaOrcamentaria',

  props: {
    filters: {
      type: Object,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  emits: ['realodData'],

  data() {
    return {
      naturezasOrcamentarias: [],
      codTBOrcamento: '',
      disableButton: false,
    }
  },

  methods: {
    async getNaturezasOrcamentariasSemAssociacao() {
      try {
        this.naturezasOrcamentarias = await this.$store.dispatch(
          'getNaturezasOrcamentariasSemAssociacao',
          this.filters,
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async createAssociacaoNaturezaOrcamentaria() {
      if (!this.v$.$invalid) {
        try {
          this.disableButton = true
          const response = await this.$store.dispatch(
            'saveAssociacaoNaturezaOrcamentaria',
            {
              codCCustoPai: this.filters.codCCustoPai,
              codCCustoFilho: this.filters.codCCustoFilho,
              orcamentoId: this.filters.orcamentoId,
              naturezaOrcamentaria: {
                codTBOrcamento: this.codTBOrcamento,
              },
            },
          )
          this.$emit('realodData')
          this.$root.$refs.notification.success(response.message)
          this.disableButton = false
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      codTBOrcamento: {
        required,
      },
    }
  },

  mounted() {
    this.getNaturezasOrcamentariasSemAssociacao()

    window.$('.select2').select2({ width: '100%' })
  },
}
</script>
